import React from "react";
import { SubmitNameForCalling } from "./submit-name-for-calling";

interface Props {}

export function SubmitNameForCallingRoute(props: Props) {
  return <SubmitNameForCalling />;
}
